import { jsx } from "react/jsx-runtime";
import { cva } from "@/styled-system/css";
import { Heading as Heading$1 } from "@zillow/constellation-10";
import PropTypes from "prop-types";
import "react";
import { migrateFontFamily, migrateTypographyToken } from "../../utils/token-migration/v8-to-v10.esm.js";
import { resolveColor, resolveSpacing, resolveTextAlign, v8ResponsiveToPanda } from "../../utils/token-migration/migrate-responsive.esm.js";
const Placements = {
  page: "page",
  post: "post"
};
const headingRecipe = cva({
  variants: {
    marginBlockStart: {
      none: {
        marginBlockStart: "none"
      },
      tightest: {
        marginBlockStart: "tightest"
      },
      tighter: {
        marginBlockStart: "tighter"
      },
      tight: {
        marginBlockStart: "tight"
      },
      default: {
        marginBlockStart: "default"
      },
      loose: {
        marginBlockStart: "loose"
      },
      looser: {
        marginBlockStart: "looser"
      },
      "layout.tightest": {
        marginBlockStart: "layout.tightest"
      },
      "layout.tighter": {
        marginBlockStart: "layout.tighter"
      },
      "layout.tight": {
        marginBlockStart: "layout.tight"
      },
      "layout.default": {
        marginBlockStart: "layout.default"
      },
      "layout.loose": {
        marginBlockStart: "layout.loose"
      },
      "layout.looser": {
        marginBlockStart: "layout.looser"
      },
      "layout.loosest": {
        marginBlockStart: "layout.loosest"
      },
      "layout.vast.default": {
        marginBlockStart: "layout.vast.default"
      },
      "layout.vast.loose": {
        marginBlockStart: "layout.vast.loose"
      },
      "layout.vast.looser": {
        marginBlockStart: "layout.vast.looser"
      },
      "-tightest": {
        marginBlockStart: "-tightest"
      },
      "-tighter": {
        marginBlockStart: "-tighter"
      },
      "-tight": {
        marginBlockStart: "-tight"
      },
      "-default": {
        marginBlockStart: "-default"
      },
      "-loose": {
        marginBlockStart: "-loose"
      },
      "-looser": {
        marginBlockStart: "-looser"
      },
      "-layout.looser": {
        marginBlockStart: "-layout.looser"
      },
      "-layout.vast.default": {
        marginBlockStart: "-layout.vast.default"
      },
      "-layout.vast.loose": {
        marginBlockStart: "-layout.vast.loose"
      }
    },
    marginBlockEnd: {
      none: {
        marginBlockEnd: "none"
      },
      tightest: {
        marginBlockEnd: "tightest"
      },
      tighter: {
        marginBlockEnd: "tighter"
      },
      tight: {
        marginBlockEnd: "tight"
      },
      default: {
        marginBlockEnd: "default"
      },
      loose: {
        marginBlockEnd: "loose"
      },
      looser: {
        marginBlockEnd: "looser"
      },
      "layout.tightest": {
        marginBlockEnd: "layout.tightest"
      },
      "layout.tighter": {
        marginBlockEnd: "layout.tighter"
      },
      "layout.tight": {
        marginBlockEnd: "layout.tight"
      },
      "layout.default": {
        marginBlockEnd: "layout.default"
      },
      "layout.loose": {
        marginBlockEnd: "layout.loose"
      },
      "layout.looser": {
        marginBlockEnd: "layout.looser"
      },
      "layout.loosest": {
        marginBlockEnd: "layout.loosest"
      },
      "layout.vast.default": {
        marginBlockEnd: "layout.vast.default"
      },
      "layout.vast.loose": {
        marginBlockEnd: "layout.vast.loose"
      },
      "layout.vast.looser": {
        marginBlockEnd: "layout.vast.looser"
      },
      "-tightest": {
        marginBlockEnd: "-tightest"
      },
      "-tighter": {
        marginBlockEnd: "-tighter"
      },
      "-tight": {
        marginBlockEnd: "-tight"
      },
      "-default": {
        marginBlockEnd: "-default"
      },
      "-loose": {
        marginBlockEnd: "-loose"
      },
      "-looser": {
        marginBlockEnd: "-looser"
      },
      "-layout.looser": {
        marginBlockEnd: "-layout.looser"
      },
      "-layout.vast.default": {
        marginBlockEnd: "-layout.vast.default"
      },
      "-layout.vast.loose": {
        marginBlockEnd: "-layout.vast.loose"
      }
    },
    textAlign: {
      inherit: {
        textAlign: "inherit"
      },
      left: {
        textAlign: "left"
      },
      center: {
        textAlign: "center"
      },
      right: {
        textAlign: "right"
      }
    },
    color: {
      "text.neutral": {
        color: "text.neutral"
      },
      "text.neutral-fixed": {
        color: "text.neutral-fixed"
      },
      "text.subtle": {
        color: "text.subtle"
      },
      "text.accent.aqua.strong": {
        color: "text.accent.aqua.strong"
      },
      "text.accent.brand.hero": {
        color: "text.accent.brand.hero"
      },
      "text.accent.blue.strong": {
        color: "text.accent.blue.strong"
      },
      "text.accent.orange.strong": {
        color: "text.accent.orange.strong"
      },
      "text.accent.purple.strong": {
        color: "text.accent.purple.strong"
      },
      "text.accent.green.strong": {
        color: "text.accent.green.strong"
      },
      "text.accent.teal.strong": {
        color: "text.accent.teal.strong"
      }
    }
  }
});
const POST_TEXT_STYLE_BY_LEVEL = {
  1: "heading-xs",
  // v8: default:h4, md/xl:h3
  2: "body-lg-bold",
  // v8: default:h5, md/xl:h4
  3: "body-bold",
  // v8: default:h6, md/xl:h5
  4: "body-bold",
  // v8: default:h6, md/xl:h6
  5: "body-sm-bold",
  // v8: bodySmallHeading at all breakpoints
  6: "fineprint-bold"
  // v8: finePrintHeading at all breakpoints
};
const POST_RESPONSIVE_FONT_CSS_BY_LEVEL = {
  1: {
    fontSize: {
      base: "heading-xs",
      lg: "heading-sm"
    },
    lineHeight: {
      base: "heading-xs",
      lg: "heading-sm"
    }
  },
  2: {
    fontSize: {
      base: "body-lg",
      lg: "heading-xs"
    },
    lineHeight: {
      base: "body-lg",
      lg: "heading-xs"
    }
  },
  3: {
    fontSize: {
      base: "body",
      lg: "body-lg"
    },
    lineHeight: {
      base: "body",
      lg: "body-lg"
    }
  }
  // h4-h6 don't scale responsively in posts
};
const POST_MARGINS = {
  2: {
    marginBlockStart: "default",
    marginBlockEnd: "tight"
  },
  3: {
    marginBlockStart: "default",
    marginBlockEnd: "tighter"
  },
  4: {
    marginBlockStart: "tight",
    marginBlockEnd: "tighter"
  },
  5: {
    marginBlockStart: "tight",
    marginBlockEnd: "tightest"
  },
  6: {
    marginBlockStart: "tight",
    marginBlockEnd: "none"
  }
};
function resolveLevel(as, level) {
  if (typeof level === "number") return level;
  if (as) {
    const match = String(as).match(/h(\d)/);
    if (match) return parseInt(match[1], 10);
  }
  return 2;
}
const TEXT_STYLE_TO_FONT_PROPS = {
  "heading-xl": {
    fontSize: "heading-xl",
    lineHeight: "heading-xl"
  },
  "heading-lg": {
    fontSize: "heading-lg",
    lineHeight: "heading-lg"
  },
  "heading-md": {
    fontSize: "heading-md",
    lineHeight: "heading-md"
  },
  "heading-sm": {
    fontSize: "heading-sm",
    lineHeight: "heading-sm"
  },
  "heading-xs": {
    fontSize: "heading-xs",
    lineHeight: "heading-xs"
  },
  "body-lg-bold": {
    fontSize: "body-lg",
    lineHeight: "body-lg"
  },
  "body-bold": {
    fontSize: "body",
    lineHeight: "body"
  },
  "body-sm-bold": {
    fontSize: "body-sm",
    lineHeight: "body-sm"
  },
  "fineprint-bold": {
    fontSize: "fineprint",
    lineHeight: "fineprint"
  }
};
function buildResponsiveFontCss(breakpointMap) {
  const fontSize = {};
  const lineHeight = {};
  Object.entries(breakpointMap).forEach(([pandaKey, textStyleValue]) => {
    const fontProps = TEXT_STYLE_TO_FONT_PROPS[textStyleValue];
    if (fontProps) {
      fontSize[pandaKey] = fontProps.fontSize;
      lineHeight[pandaKey] = fontProps.lineHeight;
    }
  });
  return {
    fontSize,
    lineHeight
  };
}
function toResponsiveTextStyle(value) {
  if (!value) return value;
  if (value.startsWith("responsive.")) return value;
  if (value.startsWith("heading-") || value === "body-lg-bold") {
    return `responsive.${value}`;
  }
  return value;
}
function resolveTextStyleAndResponsive(fontType, textStyle) {
  if (textStyle) {
    if (typeof textStyle === "object") {
      const keys = Object.keys(textStyle);
      if (keys.length === 1) {
        const value = textStyle.default || Object.values(textStyle)[0];
        return {
          textStyle: toResponsiveTextStyle(value)
        };
      }
      const breakpointMap = v8ResponsiveToPanda(textStyle);
      const base = breakpointMap.base || textStyle.default || Object.values(textStyle)[0];
      return {
        textStyle: base,
        responsiveFontCss: buildResponsiveFontCss(breakpointMap)
      };
    }
    return {
      textStyle: toResponsiveTextStyle(textStyle)
    };
  }
  if (!fontType) return {};
  if (typeof fontType === "string") {
    return {
      textStyle: toResponsiveTextStyle(migrateTypographyToken(fontType))
    };
  }
  if (typeof fontType === "object") {
    const keys = Object.keys(fontType);
    if (keys.length === 1) {
      const baseValue = fontType.default || Object.values(fontType)[0];
      return {
        textStyle: toResponsiveTextStyle(migrateTypographyToken(baseValue))
      };
    }
    const breakpointMap = v8ResponsiveToPanda(fontType, migrateTypographyToken);
    const base = breakpointMap.base || migrateTypographyToken(fontType.default || Object.values(fontType)[0]);
    return {
      textStyle: base,
      responsiveFontCss: buildResponsiveFontCss(breakpointMap)
    };
  }
  return {};
}
function collectSpacing({
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  margin
}) {
  const result = {
    marginTop,
    marginBottom,
    marginLeft,
    marginRight
  };
  if (margin && typeof margin === "object") {
    Object.entries(margin).forEach(([key, value]) => {
      if (value && !result[key]) {
        result[key] = value;
      }
    });
  }
  return result;
}
const Heading = ({
  placement,
  as,
  level,
  fontType,
  textStyle,
  fontColor,
  textAlign,
  margin,
  marginTop,
  marginBottom,
  marginLeft,
  marginRight,
  fontFamily,
  css: _cssProp,
  children,
  ...rest
}) => {
  const resolvedLevel = resolveLevel(as, level);
  const resolvedFontFamily = migrateFontFamily(fontFamily);
  if (placement === Placements.post) {
    const postResolvedColor = resolveColor(fontColor);
    const postTextStyle = POST_TEXT_STYLE_BY_LEVEL[resolvedLevel] || "heading-xs";
    const postMargins = POST_MARGINS[resolvedLevel] || {};
    const postResponsiveFontCss = POST_RESPONSIVE_FONT_CSS_BY_LEVEL[resolvedLevel];
    return /* @__PURE__ */ jsx(Heading$1, { level: resolvedLevel, textStyle: postTextStyle, fontFamily: resolvedFontFamily, css: {
      color: postResolvedColor || "inherit",
      ...headingRecipe.raw(postMargins),
      ...postResponsiveFontCss
    }, ...rest, children });
  }
  const {
    textStyle: resolvedTextStyle,
    responsiveFontCss
  } = resolveTextStyleAndResponsive(fontType, textStyle);
  const spacing = collectSpacing({
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    margin
  });
  const resolvedMarginTop = resolveSpacing(spacing.marginTop);
  const resolvedMarginBottom = resolveSpacing(spacing.marginBottom);
  const resolvedTextAlign = resolveTextAlign(textAlign);
  const resolvedColor = resolveColor(fontColor);
  const recipeProps = {};
  const responsiveCss = {};
  if (typeof resolvedMarginTop === "string") {
    recipeProps.marginBlockStart = resolvedMarginTop;
  } else if (resolvedMarginTop) {
    responsiveCss.marginBlockStart = resolvedMarginTop;
  }
  if (typeof resolvedMarginBottom === "string") {
    recipeProps.marginBlockEnd = resolvedMarginBottom;
  } else if (resolvedMarginBottom) {
    responsiveCss.marginBlockEnd = resolvedMarginBottom;
  }
  if (typeof resolvedTextAlign === "string") {
    recipeProps.textAlign = resolvedTextAlign;
  } else if (resolvedTextAlign) {
    responsiveCss.textAlign = resolvedTextAlign;
  }
  if (resolvedColor) {
    recipeProps.color = resolvedColor;
  }
  const cssProps = {
    // Override v10 Heading's default text.neutral so color inherits from
    // parent (e.g. Group with fontColor). Explicit colors from recipeProps
    // will override this since they come from headingRecipe.raw().
    ...!resolvedColor && {
      color: "inherit"
    },
    ...headingRecipe.raw(recipeProps),
    ...responsiveCss,
    ...responsiveFontCss
  };
  return /* @__PURE__ */ jsx(Heading$1, { level: resolvedLevel, textStyle: resolvedTextStyle, fontFamily: resolvedFontFamily, css: cssProps, ...rest, children });
};
Heading.propTypes = {
  as: PropTypes.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  children: PropTypes.node,
  css: PropTypes.object,
  fontColor: PropTypes.string,
  fontType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  margin: PropTypes.object,
  marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  marginLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  marginRight: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  marginTop: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placement: PropTypes.oneOf(Object.keys(Placements)),
  textAlign: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  textStyle: PropTypes.string
};
export {
  Heading as default
};
